/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketCloseCheckDto } from '../../models/ticket-close-check-dto';
import { TicketCloseCheckResponse } from '../../models/ticket-close-check-response';

export interface TicketControllerCloseCheck$Params {
      body: TicketCloseCheckDto
}

export function ticketControllerCloseCheck(http: HttpClient, rootUrl: string, params: TicketControllerCloseCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketCloseCheckResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerCloseCheck.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketCloseCheckResponse;
      }>;
    })
  );
}

ticketControllerCloseCheck.PATH = '/ticket/batch/close-check';
